import { ChainClock } from '@velocity-exchange/sdk';
import { OneWayValueJar } from '../utils/oneWayValueJar';
import { DevEventEmitter } from 'src/@types';
import EventEmitter from 'events';
import LoggingService from 'src/utils/LoggingService';

/**
 * Purpose of this is to function the same as the regular browser window object (an easy global place to store things) without being as
 * easily accessible by users who may open their console and try to screw with things. Static methods should make it easier to handle
 * race-conditions and other usability of this globally available stuff too.
 */
export class DriftWindow {
	public static chainClock = new ChainClock([]);
	public static shouldTrackAutoConnectStartupTimeMetrics = new OneWayValueJar(
		false
	);
	public static shouldTrackTradePageStartupTimeMetrics = new OneWayValueJar(
		false
	);
	public static forceInvariantCheckFailure = false;
	constructor() {}

	static initialise() {}

	/**
	 * Dev Event Emitter
	 */
	public static devEventEmitter =
		new EventEmitter() as unknown as DevEventEmitter;

	/*
	 * DLOB testing toggles.
	 */
	public static BREAK_BLOCKCHAIN_DLOB_FETCHING = false;
	public static BREAK_DLOB_SERVER_POLLING = false;
	public static DISABLE_AUTO_SWITCH_DLOB_SOURCE = false;

	/**
	 * Used to force display the stale page warning notification.
	 */
	public static FORCE_DISPLAY_STALE_PAGE_WARNING = false;

	/**
	 * Enable logging service for dev logs.
	 */
	public static enableLoggingService = () => {
		LoggingService.setDevLogging(true);
	};

	public static marketOrderToastTestingContext = 'blockchain_event';

	/**
	 * Dev override for isolated position liquidation state.
	 * Map<`${userKey}-${marketIndex}`, expirationTimestamp>
	 */
	public static devIsolatedLiquidationOverrides: Map<string, number> =
		new Map();
}
